module.exports = __webpack_public_path__ + "img/issuelog-icon-disabled.f0d47126.svg";